import axios from 'axios'
import * as querystring from 'querystring'

import config from '../config/urlConfig'
import formatAxiosError from '../util/formatAxiosError'
import axiosOptions from '../const/axios-options'

export default class {
    static getEmail(username: string, tokenCapCha: string) {
        return axios
            .post(`${config.app.api_chung_thuc}/get-email`, {
                username: username,
                capcha: tokenCapCha
            }, axiosOptions)
            .then(response => {
                return response.data
            })
            .catch(error => {
                let formatedError = formatAxiosError(error)
                throw formatedError
            })
    }

    static confrimChangePassword(username: string) {
        return axios
            .post(`${config.app.api_chung_thuc}/reset-password`, {
                username: username
            }, axiosOptions)
            .then(response => {
                return response.data
            })
            .catch(error => {
                let formatedError = formatAxiosError(error)
                throw formatedError
            })
    }

    static changePassword(newPassword: string, token: string) {
        return axios
            .post(`${config.app.api_chung_thuc}/change-password`, {
                newpassword: newPassword,
                token: token,
            })
            .then(response => {
                return response.data
            })
            .catch(error => {
                let formatedError = formatAxiosError(error)
                throw formatedError
            })
    }
}